<div class="nutrition-card-container">
  <div class="card-background">

    <div class="calorie-count-main">
      {{ currentCalories }} Kcal <div class="dateToday">{{ getFormattedDisplayDate() | translate }}</div>
    </div>
<div class="totalBar" [style.background]="getRatioGradient()"></div>
    <div class="macro-breakdown">

      <div class="macro-row">
        <span class="macro-label">Fats</span>
        <span class="macro-value">{{ fatsEaten }}g</span>
        <div class="bar-container">
          <div class="bar-gray" [style.background-color]="barGrayColor"></div>
          <div
            class="bar-filled"
            [style.background-color]="fatsBarColor"
            [style.width]="getMacroPercentage(fatsEaten, macroTotal)"
          ></div>
        </div>
      </div>

      <div class="macro-row">
        <span class="macro-label">Carbs</span>
        <span class="macro-value">{{ carbsEaten }}g</span>
        <div class="bar-container">
          <div class="bar-gray" [style.background-color]="barGrayColor"></div>
          <div
            class="bar-filled"
            [style.background-color]="carbsBarColor"
            [style.width]="getMacroPercentage(carbsEaten, macroTotal)"
          ></div>
        </div>
      </div>

         <div class="macro-row">
        <span class="macro-label">Protein</span>
        <span class="macro-value">{{ proteinEaten }}g</span>
        <div class="bar-container">
          <div class="bar-gray" [style.background-color]="barGrayColor"></div>
          <div
            class="bar-filled"
            [style.background-color]="proteinBarColor"
            [style.width]="getMacroPercentage(proteinEaten, macroTotal)"
          ></div>
        </div>
      </div>
      
    </div>
  </div>
</div>